import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from 'moment'
import {kebabCase} from 'lodash'
import timeMixins from '@/mixins/time';

export default {
    name: 'courses-events',
    mixins: [timeMixins],
    data() {
        return {
            nowDate: moment(new Date()).format('YYYY-MM-DD'),
            listDates: [],
            currentMonth: '',
            currentYear: '',
        }
    },
    created() {
        this.getTimetable();
    },
    computed: {
        ...mapGetters({
            timetableLoading: 'courses/timetableLoading',
            timetable: 'courses/timetable',
            user: 'user/user'
        }),
        getSelectedDayEvents() {
            return this.listDates.find(e => e.active) || {}
        },

        firstDay() {
            if (!this.listDates.length) return {};

            let day = this.listDates[0];

            return {
                year: moment(day.fullDate).format('YYYY'),
                month: this.capitalize(moment(day.fullDate).format('MMMM'))
            };
        },

        lastDay() {
            if (!this.listDates.length) return {};

            let day = this.listDates[this.listDates.length - 1];

            return {
                year: moment(day.fullDate).format('YYYY'),
                month: this.capitalize(moment(day.fullDate).format('MMMM'))
            };
        }
    },
    methods: {
        ...mapActions({
            fetchList: 'courses/GET_TIMETABLE'
        }),
        ...mapMutations({
            setTimetable: 'courses/SET_TIMETABLE'
        }),

        getTimetable(date) {
            this.fetchList({
                slug: this.$route.params.item,
                date: date

            }).then(() => {
                this.concatDatesWithResponse();
                this.init(date);
            })
        },

        init(date) {
            moment.locale(this.$store.getters.currentLanguage.translationKey);

            const firstDateWeek = moment(date || this.nowDate).startOf('isoWeek').format('YYYY-MM-DD');
            const lastDateWeek = moment(firstDateWeek).add(14, 'days').format('YYYY-MM-DD');

            const dates = this.getRange(firstDateWeek, lastDateWeek, 'days');
            const currentMount = moment(this.nowDate).format('X');

            this.listDates = dates.map(e => {
                return {
                    events: [],
                    fullDate: e,
                    active: false,
                    prevMount: moment(e).format('X') < currentMount,
                    day: moment(e).format('DD'),
                };
            });

            this.concatDatesWithResponse();
            this.changeActiveDay()
        },
        concatDatesWithResponse() {
            for (let i in this.timetable) {
                this.listDates.forEach((t, index) => {
                    if (i == t.fullDate.replace(/-/g, '')) {
                        this.listDates[index].events = this.timetable[i]
                    }
                });
            }
        },
        changeActiveDay(date = this.nowDate) {
            this.listDates.map(e => {
                if (e.fullDate === date) {
                    e.active = true;
                    this.currentMonth = this.capitalize(moment(e.fullDate).format('MMMM'));
                    this.currentYear = moment(e.fullDate).format('YYYY');
                } else {
                    e.active = false
                }
                return e
            })
        },
        getRange(startDate, endDate, type) {
            let fromDate = moment(startDate);
            let toDate = moment(endDate);
            let diff = toDate.diff(fromDate, type);
            let range = [];
            for (let i = 0; i < diff; i++) {
                range.push(moment(startDate).add(i, type).format('YYYY-MM-DD'))
            }
            return range
        },
        capitalize(val) {
            return val.charAt(0).toUpperCase() + val.slice(1)
        },
        toKebabKase(name) {
            return kebabCase(name)
        },
        formattedTime(item) {
            return `${moment(item.startedAt).format('ddd, HH:mm')} (UTC ${this.utcOffsetByDate(item.startedAt)})`;
        },
        declensionWord(count) {
            let titles = [this.$t('hour1'), this.$t('hour2'), this.$t('hour3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        formattedRoute(item) {
            item.type = kebabCase(item.type);
            if (item.type === 'event') {
                return {
                    name: 'course-event-detail',
                    params: {
                        item: this.$route.params.item,
                        eventSlug: item.slug
                    },
                }
            } else if (item.type === 'live-stream') {
                return {
                    name: 'course-stream-detail',
                    params: {
                        item: this.$route.params.item,
                        streamSlug: item.slug
                    }
                }
            } else if (item.type === 'qa-session') {
                return {
                    name: 'course-material-detail',
                    params: {
                        item: this.$route.params.item,
                        materialType: 'qa-sessions',
                        materialSlug: item.slug
                    },
                }
            } else if (item.type === 'meetup') {
                return {
                    name: 'course-material-detail',
                    params: {
                        item: this.$route.params.item,
                        materialType: 'meetups',
                        materialSlug: item.slug
                    },
                }
            } else if (item.type === 'bonus') {
                return {
                    name: 'course-material-detail',
                    params: {
                        item: this.$route.params.item,
                        materialType: 'bonuses',
                        materialSlug: item.slug
                    },
                }
            } else if (item.type === 'home-work') {
                return {
                    name: 'home-work-rules',
                    params: {
                        item: this.$route.params.item,
                        moduleSlug: item.module.data.slug,
                        testId: item.slug
                    }
                }
            } else if (item.type === 'home-work-ending') {
                return {
                    name: 'home-work-rules',
                    params: {
                        item: this.$route.params.item,
                        moduleSlug: item.module.data.slug,
                        testId: item.slug
                    }
                }
            } else if (item.type === 'graduate-work') {
                return {
                    name: 'graduate-work-rules',
                    params: {
                        item: this.$route.params.item
                    }
                }
            } else if (item.type === 'gradaute-work-ending') {
                return {
                    name: 'graduate-work-rules',
                    params: {
                        item: this.$route.params.item
                    }
                }
            } else if (item.type === 'lesson') {
                return {
                    name: 'courses-lesson-detail',
                    params: {
                        item: this.$route.params.item,
                        moduleSlug: item.module.data.slug,
                        lessonSlug: item.slug
                    }
                }
            }
        },

        onPrev() {
            let firstDay = this.listDates[0];
            let firstDate = firstDay.fullDate;

            let prevWeekFirstDay = moment(firstDate).subtract(14, 'days').format('YYYY-MM-DD');

            this.getTimetable(prevWeekFirstDay)
        },

        onNext() {
            let firstDay = this.listDates[0];
            let firstDate = firstDay.fullDate;

            let nextWeekFirstDay = moment(firstDate).add('days', 14).format('YYYY-MM-DD');

            this.getTimetable(nextWeekFirstDay)
        },

        getItemCnf(item) {
            let info = {};

            if (item.userGraduateWork.data.id) info = item.userGraduateWork.data;
            if (item.userHomeWork.data.id) info = item.userHomeWork.data;
            if (item.userLesson.data.id) info = item.userLesson.data;


            return {
                status: info.status,
                msg: info.reasonOfLocking
            }
        }
    },
    destroyed() {
        this.setTimetable(null)
    }
}
